import { $httpFhirApi } from '@/common/api/httpFhir.service';
import { $log } from '@/common/api/log.service';
import { Reference } from '@/fhirworks';

const postProcess = function (actions) {
    actions.forEach((item) => {
        if (item.action === 'sync') {
            item['resource'].setObjectSaved();
        }
    });
};

async function postTransaction(entry, returnTransaction = false) {
    let transaction = { type: 'transaction', entry: entry };
    // filter out empty items
    transaction.entry = transaction.entry.filter((item) => item);
    // if this is a subflow then just return the transactions
    if (returnTransaction) return { transaction: transaction };

    if (!transaction.entry.length) return;

    // extract post process actions
    let postProcessActions = [];
    transaction.entry.forEach((entry) => {
        if (entry.postProcess) {
            postProcessActions.push(entry.postProcess);
            delete entry.postProcess;
        }
    });
    let resultCollection = [];
    await $httpFhirApi
        .post('/', transaction)
        .then((transactionResult) => {
            resultCollection = transactionResult.data;
            postProcess(postProcessActions);
        })
        .catch((error) => {
            // Surface the Aidbox OperationOutcome instead of swallowing it — a rejected
            // POST (e.g. a payer-less /Claim) otherwise fails silently and the charge never
            // marks billed (#4982). Guard the log call so a logging failure can never
            // change this function's contract of returning null on a failed transaction.
            try {
                $log.error(
                    'FHIR transaction failed',
                    JSON.stringify({
                        status: error?.response?.status,
                        operationOutcome: error?.response?.data,
                        requests: transaction.entry.map((e) => e?.request && `${e.request.method} ${e.request.url}`).filter(Boolean),
                    }),
                );
            } catch {
                console.error('FHIR transaction failed', error);
            }
            resultCollection = null;
        });
    return resultCollection;
}

function getReference(resource, toJson) {
    if (!resource?.id) return undefined;
    const reference = new Reference({ id: resource.id, resourceType: resource.resourceType });
    reference.display = resource.fullName || resource.name || resource.title || resource.originalComplaint || resource.display;
    return toJson ? reference.toJSON() : reference;
}

export function useWorkflow() {
    return { postTransaction, getReference };
}
